<script>
    export let size = '0.75rem';
    export let speed = '0.75s';
    export let color = 'var(--color-text)';
    export let stroke = '0.15rem';

    $: style = [
        size ? `--spinner-size: ${size};` : '',
        speed ? `--spinner-speed: ${speed};` : '',
        color ? `--spinner-color: ${color};` : '',
        stroke ? `--spinner-stroke: ${stroke};` : '',
    ].join('');
</script>

<span {style} />
<style>span {
    pointer-events: none;
    border: var(--spinner-stroke) solid var(--spinner-color);
    border-right-color: transparent;
    width: var(--spinner-size);
    height: var(--spinner-size);
    border-radius: 50%;
    animation: spinner-rotation var(--spinner-speed) infinite ease-out;
    display: inline-block;
    vertical-align: middle;
}
@keyframes spinner-rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}
</style>